<div class="modules-page" *ngIf="isBaseRoute()">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">
                    {{ isCreateRoute() ? 'CREAR MÓDULO' : 'MÓDULOS' }}
                </h1>
                <p class="page-subtitle text-muted" *ngIf="!isCreateRoute()">
                    Gestione módulos del sistema: cree, edite y controle la
                    visibilidad de los módulos
                </p>
            </div>
            <div class="header-actions">
                <button
                    mat-raised-button
                    color="primary"
                    class="me-2"
                    (click)="onMenuGroups()"
                    matTooltip="Gestionar grupos de menú"
                >
                    <mat-icon>folder</mat-icon>
                    Grupos de Menú
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    class="me-2"
                    (click)="onReportCategories()"
                    matTooltip="Categorizar reportes Power BI"
                >
                    <mat-icon>analytics</mat-icon>
                    Categorías KPI
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="onCreateModule()"
                    matTooltip="Crear nuevo módulo"
                >
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div class="modules-list-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>
                        <!-- Nombre Column -->
                        <ng-container matColumnDef="name">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                class="pl-0"
                            >
                                Nombre
                            </th>
                            <td mat-cell *matCellDef="let element" class="pl-0">
                                <div class="module-info">
                                    <h6 class="mt-0 mb-0">
                                        {{ element.name }}
                                    </h6>
                                    <span class="text-body">{{
                                        element.code
                                    }}</span>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Código Column -->
                        <ng-container matColumnDef="code">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Código
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <code>{{ element.code }}</code>
                            </td>
                        </ng-container>

                        <!-- Grupo de Menú Column -->
                        <ng-container matColumnDef="menuGroup">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Grupo de Menú
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.menuGroup }}
                            </td>
                        </ng-container>

                        <!-- Orden Column -->
                        <ng-container matColumnDef="order">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Orden
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.order }}
                            </td>
                        </ng-container>

                        <!-- Ícono Column -->
                        <ng-container matColumnDef="icon">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Ícono
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <i-feather
                                    *ngIf="element.icon && !element.icon.startsWith('mat:')"
                                    [name]="element.icon"
                                    style="width: 18px; height: 18px"
                                ></i-feather>
                                <span
                                    *ngIf="element.icon && element.icon.startsWith('mat:')"
                                    class="material-symbols-outlined"
                                    style="font-size: 18px;"
                                    >{{ element.icon.slice(4) }}</span
                                >
                                <span *ngIf="!element.icon" class="text-muted"
                                    >-</span
                                >
                            </td>
                        </ng-container>

                        <!-- Estado Column -->
                        <ng-container matColumnDef="status">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Estado
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    class="trinta-badge fw-medium d-inline-block"
                                    *ngIf="element.status === 'active'"
                                >
                                    Activo
                                </span>
                                <span
                                    class="trinta-badge fw-medium onHand d-inline-block"
                                    *ngIf="element.status === 'inactive'"
                                >
                                    Inactivo
                                </span>
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                class="text-end pr-0"
                            ></th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="text-end pr-0"
                            >
                                <div class="action">
                                    <button
                                        type="button"
                                        mat-button
                                        class="p-0 min-w-auto lh-1 h-auto"
                                        (click)="editModule(element)"
                                    >
                                        <i class="ri-edit-line"></i>
                                    </button>
                                    <button
                                        type="button"
                                        mat-button
                                        class="p-0 min-w-auto lh-1 h-auto"
                                        (click)="deleteModule(element)"
                                    >
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>
                </div>
                <mat-paginator
                    [pageSizeOptions]="[10, 25, 50, 100]"
                ></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<router-outlet></router-outlet>
